export type TagType =
  | 'UserTaggings::UserRole'
  | 'UserTaggings::UserAuthorship'
  | 'UserTaggings::UserTopic';

export enum QuestionType {
  SingleSelect = 'SingleSelect',
  SingleSelectColumns = 'SingleSelectColumns',
  MultiSelect = 'MultiSelect',
  Freeform = 'Freeform',
  RI = 'RI',
}

export type UserTaggingQuestion =
  | FreeformQuestion
  | SelectQuestion
  | RIQuestion;

interface BaseQuestion {
  prompt: string;
  subprompt?: string;
  questionType: QuestionType;
  maxAnswers?: number;
  userTaggingType: TagType;
}

export interface FreeformQuestion extends BaseQuestion {
  questionType: QuestionType.Freeform;
}

export interface RIQuestion extends BaseQuestion {
  questionType: QuestionType.RI;
}

export interface SelectQuestion extends BaseQuestion {
  questionType:
    | QuestionType.MultiSelect
    | QuestionType.SingleSelect
    | QuestionType.SingleSelectColumns;
  userTags: UserTag[];
}

/** For the UserTaggings user tag polymorphic models e.g. UserTaggings::UserRole */
export type UserTag = {
  userTagId: number;
  userTagText: string;
};

export type numberMap = { [K in number]: number | undefined };

export enum AnswerType {
  default,
  checkbox,
  radio,
  freeform,
}

export interface Work {
  id: number;
  title: string;
  url: string;
  attachment?: {
    id: number;
    url: string;
    thumbnailUrl: string;
    fileType: string;
  };
  author: {
    displayName: string;
    photoUrl: string;
  };
  bulkDownloadPurchased?: boolean;
}
